var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Edit access permission",
        description:
          "Manage user access to the client database with tailored restrictions.",
        label: "Update",
        submitLoading: _vm.submitLoading,
        disabled: _vm.isDisabledSubmit
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSubmit
      }
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col gap-5 px-8", style: { width: "40rem" } },
        [
          _c(
            "div",
            { staticClass: "grid grid-cols-2 gap-4" },
            _vm._l(_vm.typeOptions, function(opt) {
              return _c(
                "div",
                {
                  key: opt.value,
                  staticClass:
                    "py-4 px-4 flex flex-col items-center justify-center gap-2 flex-wrap rounded border cursor-pointer",
                  class: [
                    _vm.typeInput === opt.value
                      ? "border-light-purple"
                      : "border-slate-400"
                  ],
                  on: {
                    click: function($event) {
                      _vm.typeInput = opt.value
                    }
                  }
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-6 h-6",
                    class: { "opacity-50": _vm.typeInput !== opt.value },
                    attrs: { icon: opt.icon }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-col text-center" },
                    [
                      _c("BlTextBody2", {
                        staticClass: "font-bold",
                        class: {
                          "text-light-purple": _vm.typeInput === opt.value
                        },
                        attrs: { text: opt.label }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", { attrs: { text: opt.desc } })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.typeInput === "all_clients"
            ? _c("div", { staticClass: "flex flex-col gap-1" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "py-2 px-4 flex flex-col gap-1 rounded bg-cornflower-200"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "h-4 w-4",
                          attrs: { icon: "pin", color: "cornflower-8" }
                        }),
                        _vm._v(" "),
                        _c("BlTextSubtitle3", {
                          staticClass: "text-cornflower-800",
                          attrs: { text: "Permission overview" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-cornflower-800",
                          attrs: { text: _vm.user.name }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-cornflower-800",
                          attrs: { text: "will have access to" }
                        }),
                        _vm._v(" "),
                        _c("BlTextSubtitle3", {
                          staticClass: "text-cornflower-800",
                          attrs: { text: "all clients across the center." }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.typeInput === "assigned_clients"
            ? _c(
                "div",
                { staticClass: "flex flex-col gap-4" },
                [
                  _c("div", [
                    _c(
                      "div",
                      [
                        _c("BlTextSubtitle3", {
                          attrs: { text: "Include any relevant tags" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: "(optional)" } })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("BlTextBody2", {
                          attrs: { text: "Can also view clients that" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "font-bold",
                          attrs: { text: "have at least one" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: "of the specified tags." }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("BlSearchBox", {
                    attrs: {
                      type: "branch",
                      label: "Branch tags",
                      placeholder: "Type tag",
                      options: _vm.branchOptions
                    },
                    on: {
                      change: function($event) {
                        _vm.branchIdsInput = $event
                      }
                    },
                    model: {
                      value: _vm.branchIdsInput,
                      callback: function($$v) {
                        _vm.branchIdsInput = $$v
                      },
                      expression: "branchIdsInput"
                    }
                  }),
                  _vm._v(" "),
                  _c("BlSearchBox", {
                    attrs: {
                      type: "tag",
                      label: "Client tags",
                      placeholder: "Type tag",
                      options: _vm.labelOptions
                    },
                    on: {
                      change: function($event) {
                        _vm.labelIdsInput = $event
                      }
                    },
                    model: {
                      value: _vm.labelIdsInput,
                      callback: function($$v) {
                        _vm.labelIdsInput = $$v
                      },
                      expression: "labelIdsInput"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "py-2 px-4 flex flex-col gap-1 rounded bg-cornflower-200"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-2" },
                        [
                          _c("BlIcon", {
                            staticClass: "h-4 w-4",
                            attrs: { icon: "pin", color: "cornflower-8" }
                          }),
                          _vm._v(" "),
                          _c("BlTextSubtitle3", {
                            staticClass: "text-cornflower-800",
                            attrs: { text: "Permission overview" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "text-cornflower-800",
                            attrs: { text: _vm.user.name }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-cornflower-800",
                            attrs: { text: "will have access" }
                          }),
                          _vm._v(" "),
                          !_vm.totalTagAccesses
                            ? _c("BlTextSubtitle3", {
                                staticClass: "text-cornflower-800",
                                attrs: {
                                  text:
                                    "only to clients directly assigned to them."
                                }
                              })
                            : _c(
                                "span",
                                [
                                  _c("BlTextSubtitle3", {
                                    staticClass: "text-cornflower-800",
                                    attrs: {
                                      text:
                                        "only to clients directly assigned to them,"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: {
                                      text:
                                        "as well as clients tagged with at least one of"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle3", {
                                    staticClass: "text-cornflower-800",
                                    attrs: { text: _vm.totalTagAccesses }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: { text: "selected tag(s)." }
                                  })
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24b797b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24b797b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/team/EditUserAccessModal.vue
// module id = null
// module chunks = 